import { TokenListMetadata } from "./metadata";
import { OracleQuote } from "./oracle";
import { ParsedRaydiumPosition, ParsedRaydiumPool, ParsedRaydiumPoolRaw, ParsedRaydiumPositionRaw } from "./raydium";
import {
    ParsedOrcaPosition,
    ParsedOrcaPositionRaw,
    ParsedOrcaWhirlpool,
    ParsedOrcaWhirlpoolRaw,
    TokenPositionExpanded
} from "./whirlpool";

type RaydiumPoolAddress = string;

//Raw types
export interface ClpPositionInfoRaw {
    whirlpoolsToPositions: Record<string, ParsedOrcaPositionRaw[]>;
    whirlpools: Record<string, ParsedOrcaWhirlpoolRaw>;
    raydiumPoolsToPositions: Record<RaydiumPoolAddress, ParsedRaydiumPositionRaw[]>;
    raydiumPools: Record<RaydiumPoolAddress, ParsedRaydiumPoolRaw>;
}

export interface ClpPositionInfo {
    whirlpoolsToPositions: Record<string, ParsedOrcaPosition[]>;
    whirlpools: Record<string, ParsedOrcaWhirlpool>;
    raydiumPoolsToPositions: Record<RaydiumPoolAddress, ParsedRaydiumPosition[]>;
    raydiumPools: Record<RaydiumPoolAddress, ParsedRaydiumPool>;
}

export type ClmmPositionExpanded = WhirlpoolPositionExpanded | RaydiumPositionExpanded;

export function getTokenMintFromClmm(position: ClmmPositionExpanded | undefined): string | undefined {
    if (!position) return undefined;
    if ("whirlpool" in position) {
        return position.position.positionMint;
    } else {
        return position.position.nftMint;
    }
}
export function getWhirlpoolFromClmm(
    position: ClmmPositionExpanded | undefined
): WhirlpoolPositionExpanded | undefined {
    if (position && "whirlpool" in position) {
        return position;
    }
    return undefined;
}

export interface WhirlpoolPositionExpanded {
    whirlpoolMetadata: TokenListMetadata;
    whirlpoolAddress: string;
    whirlpool: ParsedOrcaWhirlpool;
    position: ParsedOrcaPosition;
    tokenA: TokenPositionExpanded;
    tokenB: TokenPositionExpanded;
    oracle: OracleQuote;
    totalPrice: number;
}

export interface RaydiumPositionExpanded {
    poolMetadata: TokenListMetadata;
    poolAddress: string;
    pool: ParsedRaydiumPool;
    position: ParsedRaydiumPosition;
    tokenA: TokenPositionExpanded;
    tokenB: TokenPositionExpanded;
    oracle: OracleQuote;
    totalPrice: number;
}
